import React, { useEffect } from "react";
import Icon from "./Icon";
import icon1 from "../assets/musical-notes.png";
import icon2 from "../assets/map.png";
import icon3 from "../assets/gallery.png";

interface props {
  startSession: () => void;
}

const ConnectionFrame: React.FC<props> = ({ startSession }) => {
  return (
    <>
      <div className="absolute top-0 left-0 h-full w-full flex justify-center items-center">
        <div className="flex flex-col max-w-[600px] w-full min-h-[400px] border-orange-600 border-2 rounded-xl">
          <div className="bg-[#FFA600] bg-opacity-10 flex-1 flex justify-center items-center border-orange-600 border-b-2">
            <h1 className="font-[Agbalumo] drop-shadow-[0_2px_2px_#684503] text-[#FF902F] text-3xl">
              Welcome to Playfinity
            </h1>
          </div>

          <div className="flex-[4] flex items-center flex-col text-center">
            <div className="flex flex-[1] justify-center gap-12 w-full items-center">
              <div className="relative top-5">
                <Icon url={icon1}></Icon>
              </div>
              <Icon url={icon2}></Icon>
              <div className="relative top-5">
                <Icon url={icon3}></Icon>
              </div>
            </div>
            <p className="font-semibold text-slate-200 flex-[2] font-sans text-base flex items-center px-5">
              Experience Playfinity on a whole new level with our web client:
              Enjoy music and immersive sound effects, explore everything in
              real time with our live map, and easily download your personal
              ride photos!
            </p>
          </div>

          <div className="bg-[#FFA600] bg-opacity-10 flex-1 flex justify-center items-center border-t-2 border-orange-600">
            <button
              onClick={startSession}
              className="
    group relative overflow-hidden
    font-[Agbalumo]
    px-6 py-2 w-1/3
    text-white rounded-lg
    bg-gradient-to-r from-[#FF6A00] to-[#FFA43C]
    shadow-md shadow-orange-900/40

    transition-all duration-300 ease-out
    hover:scale-105 hover:shadow-xl hover:shadow-orange-500/50
    active:scale-95
  "
            >
              <span className="relative z-10 drop-shadow-[0_2px_2px_#A74E00]">
                Start
              </span>

              <span
                className="
      absolute inset-0
      -translate-x-full
      bg-gradient-to-r from-transparent via-white/30 to-transparent
      skew-x-[-20deg]
      group-hover:animate-[shine_1s_ease-in-out]
    "
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectionFrame;
